module.exports = __webpack_public_path__ + "img/GS_Profile-Jalin Meintjies.73e736ca.png";